import "./PizzeriaProducts.module.css";
import Header from "@/reusable_sections/Header";
import ProductosPoler from "./sections/ProductosPoler";
import Footer from "@/reusable_sections/Footer";
export default function PizzeriaProductsPage() {
  return <div>
      <Header />
      <ProductosPoler />
      <Footer />
    </div>;
}